// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".related-collections[data-v-5289943f]{margin-bottom:1.5rem;margin-top:-.5rem}[data-v-5289943f] .card-header-tabs{border-radius:.25rem .25rem 0 0}[data-v-5289943f] .card-header-tabs .nav-link,[data-v-5289943f] .card-header-tabs .nav-link:hover{border-radius:.25rem 0 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
